import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/home/Hero";
import { TrustMarquee } from "@/components/home/TrustMarquee";
import { OfferSection } from "@/components/home/OfferSection";
import { HowItWorks } from "@/components/home/HowItWorks";
import { Pricing } from "@/components/home/Pricing";
import { SuccessStories } from "@/components/home/SuccessStories";
import { Faq } from "@/components/home/Faq";
import { Security } from "@/components/home/Security";
import { CtaBand } from "@/components/home/CtaBand";
import { scrollToId } from "@/lib/scroll";

export default function HomePage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.slice(1)), 400);
      return () => clearTimeout(t);
    }
  }, [hash]);

  return (
    <main>
      <Hero />
      <TrustMarquee />
      <OfferSection />
      <HowItWorks />
      <Pricing />
      <SuccessStories />
      <Faq />
      <Security />
      <CtaBand />
    </main>
  );
}
